import { ref } from 'vue'
import { defineStore } from 'pinia'
import * as userApi from '@/apis/auth.api'

export const usePhonebookStore = defineStore('phonebook', () => {
  const allContacts = ref([])
  const lastModified = ref(null)
  const loaded = ref(false)

  const clear = () => {
    allContacts.value = []
    lastModified.value = null
    loaded.value = false
  }

  const formatContact = (contact) => {
    const parts = (contact.name || '').trim().split(/\s+/)
    const letter = parts[0].charAt(0).toUpperCase() + (parts[1]?.charAt(0).toUpperCase() || '')

    return {
      ...contact,
      letter: letter || '?'
    }
  }

  const fetchContacts = async(forceRefresh = false) => {
    try {
      const config = {}

      if (!forceRefresh && lastModified.value) {
        config.headers = {
          'If-Modified-Since': lastModified.value
        }
      }

      const response = await userApi.fetchUserContactsAsync(config)

      if (response.data) {
        allContacts.value = response.data
          .map(formatContact)
          .sort((a, b) => {
            const nameA = a.name || ''
            const nameB = b.name || ''
            return nameA.localeCompare(nameB)
          })

        if (response.headers && response.headers['last-modified']) {
          lastModified.value = response.headers['last-modified']
        }
      }

      loaded.value = true
    } catch (error) {
      if (error.response && error.response.status === 304) {
        console.debug('Contacts cached (304)')
        loaded.value = true
        return
      }

      console.error('Failed to fetch contacts:', error)
      throw error
    }
  }

  const deleteContact = async(id) => {
    try {
      await userApi.deleteContactAsync(id)
      allContacts.value = allContacts.value.filter(contact => contact.id !== id)
    } catch (error) {
      console.error('Failed to delete contact:', error)
      throw error
    }
  }

  return {
    allContacts,
    loaded,
    lastModified,

    fetchContacts,
    deleteContact,
    clear
  }
}, {
  persist: [
    {
      pick: ['allContacts', 'lastModified'],
      storage: localStorage
    }
  ]
})
